import { browserName } from "react-device-detect";
import { toast } from "react-toastify";

const randInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const toRankString = (rank) => {
  let _rank = rank.toString();
  let _last = _rank[_rank.length - 1];

  switch (_last) {
    case "1":
      return `${_rank}st`;
    case "2":
      return `${_rank}nd`;
    case "3":
      return `${_rank}rd`;
    default:
      return `${_rank}th`;
  }
};

const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.log(error);
  }
};

const getLocalStorage = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const delLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.log(error);
  }
};

const hasBrowserSupport = () => {
  if (
    browserName === "Chrome" ||
    browserName === "Firefox" ||
    browserName === "Edge"
  ) {
    return true;
  } else {
    toast.warn(
      "Use supported browser (Chrome 69+, Firefox 105+, Edge 79+)"
    );
    return false;
  }
};

const hasUserMedia = () => {
  let _hasUserMedia =
    navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia ||
    navigator.msGetUserMedia;

  if (_hasUserMedia) {
    return true;
  } else {
    toast.error("Camera API is not supported");
    return false;
  }
};

const hasWebWorker = () => {
  if (typeof Worker !== "undefined") {
    return true;
  } else {
    toast.error("Web Worker is not supported");
    return false;
  }
};

const hasLandScape = () => {
  if (window.screen.height < window.screen.width) {
    return true;
  } else {
    toast.warn("Use landscape mode for better experience");
    return false;
  }
};

export {
  randInt,
  toRankString,
  setLocalStorage,
  getLocalStorage,
  delLocalStorage,
  hasBrowserSupport,
  hasUserMedia,
  hasWebWorker,
  hasLandScape,
};
